import React from 'react';
import { SEO } from './components/SEO';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Trust } from './components/Trust';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans selection:bg-brand-pink selection:text-brand-text" data-id="element-0">
      <SEO data-id="element-1" />
      <TopBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Pricing data-id="element-7" />
        <Trust data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}